import type { UserFilters, UserRole } from '@models/user'
import { keyToUrl } from '@tools/common'

export const usersKeys = {
  root: (companyId?: number) => ['users', companyId ?? null] as const,
  users: (filters: UserFilters) =>
    [...usersKeys.root(filters.companyId), filters] as const,
  user: (id: number) => ['users', id] as const,
  userRoles: () => ['userRoles'] as const,
  userFeatures: (id: number) => [...usersKeys.user(id), 'features'] as const,
  usersLookup: (filters: UserFilters) => ['users', 'lookup', filters] as const,
}

export const usersUrls = {
  root: keyToUrl(usersKeys.root()),
  user: (id: number) => keyToUrl(usersKeys.user(id)),
  userRoles: keyToUrl(usersKeys.userRoles()),
  userFeatures: (userId: number) => keyToUrl(usersKeys.userFeatures(userId)),
  usersLookup: (companyId: number) =>
    keyToUrl(usersKeys.usersLookup({ companyId })),
}

export const USER_ROLES: Readonly<UserRole[]> = [
  'RINKAI_OWNER',
  'RINKAI_MANAGER',
  'COMPANY_SUPER_ADMIN',
  'COMPANY_REGIONAL_MANAGER',
  'COMPANY_MANAGER',
  'COMPANY_DISPATCHER',
  'COMPANY_DRIVER',
]

export const AVAILABLE_ROLES: Readonly<UserRole[]> = [
  'COMPANY_SUPER_ADMIN',
  'COMPANY_DISPATCHER',
  'COMPANY_DRIVER',
]

export const getAvailableUserRoles = (role: UserRole): UserRole[] => {
  return USER_ROLES.slice(USER_ROLES.indexOf(role) + 1).filter(role =>
    AVAILABLE_ROLES.includes(role),
  )
}
